import type { paths, definitions } from '@luxuryescapes/contract-trip'

export type GetTripsResponse =
  paths['/api/trips']['get']['responses']['200']['content']['application/json']

export type GetTripCollaboratorsResponse =
  paths['/api/trips/{tripId}/collaborators']['get']['responses']['200']['content']['application/json']

export type CreateTripResponse =
  paths['/api/trips']['post']['responses']['200']['content']['application/json']

export type CreateTripRequest =
  paths['/api/trips']['post']['requestBody']['content']['application/json']

export type GetTripResponse =
  paths['/api/trips/{tripId}']['get']['responses']['200']['content']['application/json']

export type TripRole = GetTripResponse['result']['role']

export type GetTripMetadataResponse =
  paths['/api/trips/{tripId}/metadata']['get']['responses']['200']['content']['application/json']

export type RefreshTripResponse =
  paths['/api/trips/{tripId}/refresh']['post']['responses']['200']['content']['application/json']

export type RecordTripViewResponse =
  paths['/api/trips/{tripId}/record-view']['post']['responses']['200']['content']['application/json']

export type DeleteTripResponse =
  paths['/api/trips/{tripId}']['delete']['responses']['200']['content']['application/json']

export type UpdateTripRequest =
  paths['/api/trips/{tripId}']['patch']['requestBody']['content']['application/json']

export type UpdateTripResponse =
  paths['/api/trips/{tripId}']['patch']['responses']['200']['content']['application/json']

export type UploadTripImageRequest =
  paths['/api/trips/{tripId}/trip-image']['post']['requestBody']['content']['application/json']

export type UploadTripImageResponse =
  paths['/api/trips/{tripId}/trip-image']['post']['responses']['200']['content']['application/json']

export type SendInviteRequest =
  paths['/api/trips/{tripId}/invitation']['post']['requestBody']['content']['application/json']

export type SendInviteResponse =
  paths['/api/trips/{tripId}/invitation']['post']['responses']['200']['content']['application/json']

export type AcceptInviteResponse =
  paths['/api/trips/{tripId}/invitations/{invitationId}/accept']['post']['responses']['200']['content']['application/json']

export type EditInviteRequest =
  paths['/api/trips/{tripId}/invitations/{invitationId}']['patch']['requestBody']['content']['application/json']

export type EditInviteResponse =
  paths['/api/trips/{tripId}/invitations/{invitationId}']['patch']['responses']['200']['content']['application/json']

export type EditInviteError =
  paths['/api/trips/{tripId}/invitations/{invitationId}']['patch']['responses']['404']['content']['application/json']

export type DeleteInviteResponse =
  paths['/api/trips/{tripId}/invitations/{invitationId}']['delete']['responses']['200']['content']['application/json']

export type EditCollaboratorRequest =
  paths['/api/trips/{tripId}/collaborators/{userId}']['patch']['requestBody']['content']['application/json']

export type EditCollaboratorResponse =
  paths['/api/trips/{tripId}/collaborators/{userId}']['patch']['responses']['200']['content']['application/json']

export type EditCollaboratorError =
  paths['/api/trips/{tripId}/collaborators/{userId}']['patch']['responses']['404']['content']['application/json']

export type RemoveCollaboratorResponse =
  paths['/api/trips/{tripId}/collaborators/{userId}']['delete']['responses']['200']['content']['application/json']

export type GetTripError =
  paths['/api/trips/{tripId}']['get']['responses']['404']['content']['application/json']

export type GetTripCollaboratorError =
  | paths['/api/trips/{tripId}/collaborators']['get']['responses']['404']['content']['application/json']

export type GetTripMetadataError =
  paths['/api/trips/{tripId}/metadata']['get']['responses']['404']['content']['application/json']

export type RefreshTripError =
  paths['/api/trips/{tripId}/refresh']['post']['responses']['404']['content']['application/json']

export type RecordTripViewError =
  paths['/api/trips/{tripId}/record-view']['post']['responses']['404']['content']['application/json']

export type CreateTripError =
  paths['/api/trips']['post']['responses']['422']['content']['application/json']

export type UpdateTripError =
  | paths['/api/trips/{tripId}']['put']['responses']['404']['content']['application/json']
  | paths['/api/trips/{tripId}']['put']['responses']['422']['content']['application/json']

export type DeleteTripError =
  paths['/api/trips/{tripId}']['delete']['responses']['404']['content']['application/json']

export type UploadTripImageError =
  | paths['/api/trips/{tripId}/trip-image']['post']['responses']['403']['content']['application/json']
  | paths['/api/trips/{tripId}/trip-image']['post']['responses']['404']['content']['application/json']
  | paths['/api/trips/{tripId}/trip-image']['post']['responses']['422']['content']['application/json']

export type SendInviteError =
  | paths['/api/trips/{tripId}/invitation']['post']['responses']['404']['content']['application/json']

export type AcceptInviteError =
  | paths['/api/trips/{tripId}/invitations/{invitationId}/accept']['post']['responses']['404']['content']['application/json']
  | paths['/api/trips/{tripId}/invitations/{invitationId}/accept']['post']['responses']['422']['content']['application/json']
  | paths['/api/trips/{tripId}/invitations/{invitationId}/accept']['post']['responses']['500']['content']['application/json']
export type RevokeInviteError =
  | paths['/api/trips/{tripId}/invitations/{invitationId}']['delete']['responses']['404']['content']['application/json']
export type RemoveCollaboratorRequest =
  paths['/api/trips/{tripId}/invitation']['post']['requestBody']['content']['application/json']

export type RemoveCollaboratorError =
  | paths['/api/trips/{tripId}/collaborators/{userId}']['delete']['responses']['404']['content']['application/json']
  | paths['/api/trips/{tripId}/collaborators/{userId}']['delete']['responses']['403']['content']['application/json']

export type GetFlightScheduleError =
  paths['/api/trips/misc/flight-schedule']['get']['responses']['502']['content']['application/json']

export type GetLowStockTripItemsResponse =
  paths['/api/trips/{tripId}/low-stock-items']['get']['responses']['200']['content']['application/json']

export type Place = definitions['place']

export type GenerateTripAiResponse =
  paths['/api/trips/generate-trip']['post']['responses']['200']['content']['application/json']

export type GenerateTripAiWithDestinationRequest =
  paths['/api/trips/v2/generate-trip']['post']['requestBody']['content']['application/json']

export type GenerateMultiDestinationTripRequest =
  paths['/api/trips/v2/generate-trip']['post']['requestBody']['content']['application/json']

export type GenerateTripThemesResponse =
  paths['/api/trips/generate-themes']['post']['responses']['200']['content']['application/json']

export type GenerateTripThemesRequest =
  paths['/api/trips/generate-themes']['post']['requestBody']['content']['application/json']

export type ChatListResponse =
  paths['/api/trips/v2/chats']['get']['responses']['200']['content']['application/json']['result']

export type TripPlannerChat = ChatListResponse[number]

export type TripPlannerChatDetails =
  paths['/api/trips/v2/chats/{chatId}']['get']['responses']['200']['content']['application/json']['result']

export type TripPlannerChatMessage = TripPlannerChatDetails['messages'][number]

export type ContractMessagePart = TripPlannerChatMessage['parts'][number]

export type ContractUIComponentData = Extract<ContractMessagePart, { type: 'ui_component' }>['data']

export const STREAM_EVENT = {
  MESSAGE_START: 'message_start',
  PARTS_UPDATE: 'parts_update',
  MESSAGE_END: 'message_end',
  ITINERARY_UPDATE_STARTED: 'itinerary_update_started',
  ITINERARY_UPDATES: 'itinerary_updates',
  CONTENT_COMPLETE: 'content_complete',
  ENRICHMENT_COMPLETE: 'enrichment_complete',
  CHAT_LOADING_STATE: 'chat_loading_state',
  HOTEL_SEARCH_RESULTS: 'hotel_search_results',
  HOTEL_SEARCH_ERROR: 'hotel_search_error',
  CHAT_UI_ACTION: 'chat_ui_action',
  STATUS: 'status',
  HEARTBEAT: 'heartbeat',
} as const

export type StreamEventType = typeof STREAM_EVENT[keyof typeof STREAM_EVENT]

export type ChatToolLoadingPhase = 'start' | 'complete'

export interface ChatToolLoadingStateData {
  kind: 'tool_call'
  phase: ChatToolLoadingPhase
  key: string
  callId: string
}

/**
 * Hotel search offer shape from stream event.
 * Mirrors the contract's hotel UI component `offers` array item shape.
 * Kept as a named interface for readability; the contract embeds this
 * as an inline type within the discriminated union so extracting it
 * directly would be brittle.
 */
export interface HotelSearchOffer {
  id: string
  name: string
  coordinates?: { lat: number; lng: number }
}

/**
 * Data shape passed when the user clicks "Map view" on a hotel carousel
 * or when hotel search results are used to populate the map.
 */
export interface HotelMapViewData {
  searchQuery: string
  offers: Array<HotelSearchOffer>
}

/**
 * Data shape passed when the user clicks "Map view" on an experience carousel.
 * Shares the same offer shape as hotels since both carry { id, name, coordinates }.
 */
export interface ExperienceMapViewData {
  searchQuery: string
  offers: Array<HotelSearchOffer>
}

/**
 * Hotel search results stream event data (SSE payload).
 * Not covered by the REST contract — hand-defined until svc-trip
 * publishes stream event schemas.
 */
export interface HotelSearchResultsData {
  searchQuery: string
  offers: Array<HotelSearchOffer>
  /** OpenAI tool call id used for correlation. */
  hotelSearchCallId?: string
}

/**
 * Hotel search error stream event data (SSE payload).
 * Not covered by the REST contract — hand-defined until svc-trip
 * publishes stream event schemas.
 */
export interface HotelSearchErrorData {
  message: string
  searchQuery?: string
  /** OpenAI tool call id used for correlation. */
  hotelSearchCallId?: string
}

export interface ChatUiActionData {
  action: 'set_right_panel_view'
  view: 'map' | 'itinerary'
  lat?: number
  lng?: number
  zoom?: number
}

/** Camera position derived from ChatUiActionData with all coordinates required. */
export type MapCameraPosition = Required<Pick<ChatUiActionData, 'lat' | 'lng' | 'zoom'>>

// Status event data — typed phases for loading indicator copy
export type StatusReasoningData = {
  phase: 'reasoning'
  summaries?: Array<string>
}

export type StatusToolCallingData = {
  phase: 'tool_calling'
  tool: string
  args: Record<string, unknown>
}

export type StatusEventData = StatusReasoningData | StatusToolCallingData

/** Tool names from status/tool_calling events. Used for label mapping and filtering. */
export const TOOL_NAME = {
  SEARCH_HOTELS: 'search_hotels',
  SEARCH_EXPERIENCES: 'search_experiences',
  SEARCH_FLIGHTS: 'search_flights',
  LOOKUP_OFFER: 'lookup_offer',
  SET_TRIP_PLANNER_VIEW: 'set_trip_planner_view',
} as const

// Enrichment status from contract — used by derived enrichment state in useItineraryUpdates
export type EnrichmentStatus = NonNullable<definitions['tripChatItem']['enrichmentStatus']>

// Re-export itinerary types for convenience
export type TripStopWithDays = definitions['tripStopWithDays']
export type TripDayWithItems = definitions['tripDayWithItems']
export type TripChatItem = definitions['tripChatItem']
export type PlaceDetail = definitions['placeDetail']

// Itinerary data types - indexed from GetItineraryResponse
export type TripItineraryData = GetItineraryResponse['result']
export type TripStop = TripItineraryData['stops'][number]
export type TripDay = TripStop['days'][number]
export type TripItineraryItem = TripDay['items'][number]
export type TripItemWithoutDay = TripStop['itemsWithoutDay'][number]

// TODO: remove these overrides once contract-trip includes isDefaultTransport on transportOption.savedItemData
type ContractTransportConnection = NonNullable<TripStop['transports']>[number]
type ContractTransportOption = ContractTransportConnection['options'][number]

export interface LeFlightBookingData {
  searchId?: string
  journeyKey?: string
  journeyId?: string
  price?: number
  currencyCode?: string
  searchExpiry?: number
  searchParams?: string
  carrierLogo?: string
}

export type TransportOption = Omit<ContractTransportOption, 'savedItemData' | 'returnLeg'> & {
  savedItemData?: ContractTransportOption['savedItemData'] & { isDefaultTransport?: boolean; departureAirport?: string; arrivalAirport?: string } & Partial<LeFlightBookingData>
  returnLeg?: TransportOption
}
export type TransportConnection = Omit<ContractTransportConnection, 'options'> & {
  options: Array<TransportOption>
}

/** savedItemData narrowed to the le_flight source variant, with FE extensions. */
export interface LeFlightSavedItemData {
  source: 'le_flight'
  airline?: string
  flightNumber?: string
  departureAirport?: string
  arrivalAirport?: string
  departureTime?: string
  arrivalTime?: string
  duration?: string
  layovers?: Array<{ airportCode?: string; airportName?: string; duration?: string }>
  cabinClass?: string
  bookingReference?: string
  flightGroupId?: string
  legOrder?: number
  farePrice?: number
  fareCurrencyCode?: string
  searchId?: string
  journeyKey?: string
  journeyId?: string
  price?: number
  currencyCode?: string
  searchExpiry?: number
  searchParams?: string
  carrierLogo?: string
  isDefaultTransport?: boolean
}

/** Type guard that narrows TransportOption.savedItemData to the le_flight shape. */
export function isLeFlightSavedItemData(data: TransportOption['savedItemData']): data is LeFlightSavedItemData {
  return data?.source === 'le_flight'
}

/** savedItemData narrowed to the custom_flight source variant (user-added via chat). */
export interface CustomFlightSavedItemData {
  source: 'custom_flight'
  airline?: string
  flightNumber?: string
  departureAirport?: string
  arrivalAirport?: string
  departureTime?: string
  arrivalTime?: string
  duration?: string
  carrierLogo?: string
  isDefaultTransport?: boolean
}

/** Type guard that narrows TransportOption.savedItemData to the custom_flight shape. */
export function isCustomFlightSavedItemData(data: TransportOption['savedItemData']): data is CustomFlightSavedItemData {
  return data?.source === 'custom_flight'
}

/** Matches either le_flight or custom_flight saved data for shared rendering logic. */
export type FlightCardSavedItemData = LeFlightSavedItemData | CustomFlightSavedItemData

/** Type guard that matches any flight source that should render as a rich tile card. */
export function isFlightCardSavedItemData(data: TransportOption['savedItemData']): data is FlightCardSavedItemData {
  return data?.source === 'le_flight' || data?.source === 'custom_flight'
}

export type StopVisitRole = definitions['stopVisit']['role']

export const STOP_VISIT_ROLE: Record<StopVisitRole, StopVisitRole> = {
  ACTIVITY: 'ACTIVITY',
  STAY: 'STAY',
  DEPARTURE: 'DEPARTURE',
  ARRIVAL: 'ARRIVAL',
  VIA: 'VIA',
} as const

export interface StreamingStopVisit extends Pick<definitions['stopVisit'], 'tripStopId' | 'startDayId' | 'endDayId' | 'role'> {
  startDayNumber?: number
  endDayNumber?: number
}

/**
 * ItineraryUpdate includes full entity data for immediate rendering.
 * The frontend can add these entities to the itinerary immediately,
 * then update them when enrichment_complete events arrive.
 *
 * Item events carry `stopVisits` for multi-stop/multi-day placement.
 * Legacy `stopId`/`dayId` are still sent by the backend for backward compat
 * but should not be used — prefer `stopVisits`.
 */
export type ItineraryUpdate =
  | { kind: 'stop_added'; stopId: number; stop: TripStopWithDays }
  | { kind: 'stop_updated'; stopId: number; stop: TripStopWithDays }
  | { kind: 'stop_deleted'; stopId: number }
  | { kind: 'day_added'; dayId: number; stopId: number; day: TripDayWithItems }
  | { kind: 'day_deleted'; dayId: number; stopId: number }
  | { kind: 'item_added'; itemId: number; stopVisits: Array<StreamingStopVisit>; item: TripChatItem; /** @deprecated use stopVisits */ stopId?: number; /** @deprecated use stopVisits */ dayId?: number }
  | { kind: 'item_updated'; itemId: number; stopVisits: Array<StreamingStopVisit>; item: TripChatItem; /** @deprecated use stopVisits */ stopId?: number; /** @deprecated use stopVisits */ dayId?: number }
  | { kind: 'item_deleted'; itemId: number; stopVisits: Array<StreamingStopVisit>; /** @deprecated use stopVisits */ stopId?: number; /** @deprecated use stopVisits */ dayId?: number }

/**
 * EnrichmentCompleteEvent is emitted when Google Places enrichment completes
 * for a specific entity. Contains the enriched data to merge into the itinerary.
 */
export type EnrichmentCompleteEvent =
  | {
    event: 'enrichment_complete'
    entityType: 'stop'
    stopId: number
    imageIds: Array<string>
    placeDetail?: PlaceDetail
  }
  | {
    event: 'enrichment_complete'
    entityType: 'item'
    itemId: number
    placeDetail?: PlaceDetail
  }

export type GenerateChatTitleResponse =
  paths['/api/trips/v2/chats/{chatId}/title']['post']['responses']['200']['content']['application/json']['result']

export type UpdateChatRequest =
  paths['/api/trips/v2/chats/{chatId}']['patch']['requestBody']['content']['application/json']

export type UpdateChatResponse =
  paths['/api/trips/v2/chats/{chatId}']['patch']['responses']['200']['content']['application/json']['result']

export type CreateMessageRequest =
  paths['/api/trips/v2/messages']['post']['requestBody']['content']['application/json']

export type ChatMessageAttachment = NonNullable<CreateMessageRequest['files']>[number]

export type CreateMessageResponse =
  paths['/api/trips/v2/messages']['post']['responses']['200']['content']['application/json']['result']

export type SubmitMessageFeedbackRequest =
  paths['/api/trips/v2/chats/{chatId}/messages/{messageId}/feedback']['post']['requestBody']['content']['application/json']

export type MessageFeedbackReaction = SubmitMessageFeedbackRequest['reaction']

export type SubmitMessageFeedbackResponse =
  paths['/api/trips/v2/chats/{chatId}/messages/{messageId}/feedback']['post']['responses']['200']['content']['application/json']['result']

export type GenerateTripThemesV2Response =
  paths['/api/trips/v2/generate-themes']['post']['responses']['200']['content']['application/json']

export type GenerateTripThemesV2Request =
  paths['/api/trips/v2/generate-themes']['post']['requestBody']['content']['application/json']

export type RegenerateDayAiResponse =
  paths['/api/trips/regenerate-day']['post']['responses']['200']['content']['application/json']

export type RegenerateDayAiRequest =
  paths['/api/trips/regenerate-day']['post']['requestBody']['content']['application/json']

export type GenerateMustDoActivitiesResponse =
  paths['/api/trips/generate-must-do-activities']['post']['responses']['200']['content']['application/json']

export type GenerateMustDoActivitiesRequest =
  paths['/api/trips/generate-must-do-activities']['post']['requestBody']['content']['application/json']

export type UpdateTravelPreferencesResponse =
  paths['/api/trips/travel-preferences']['post']['responses']['200']['content']['application/json']

export type UpdateTravelPreferencesRequest =
  paths['/api/trips/travel-preferences']['post']['requestBody']['content']['application/json']

export type UndoRegenerateDayAiResponse =
  paths['/api/trips/undo-regenerate-day']['post']['responses']['200']['content']['application/json']

export type UndoRegenerateDayAiRequest =
  paths['/api/trips/undo-regenerate-day']['post']['requestBody']['content']['application/json']

export type RegenerateItemAiResponse =
  paths['/api/trips/{tripId}/generate-alternative-item']['post']['responses']['200']['content']['application/json']

export type RegenerateItemAiRequest =
  paths['/api/trips/{tripId}/generate-alternative-item']['post']['requestBody']['content']['application/json']

export type RegenerateItemAiError =
  | paths['/api/trips/{tripId}/generate-alternative-item']['post']['responses']['400']['content']['application/json']
  | paths['/api/trips/{tripId}/generate-alternative-item']['post']['responses']['404']['content']['application/json']
  | paths['/api/trips/{tripId}/generate-alternative-item']['post']['responses']['500']['content']['application/json']

export type AddBasicActivityToTripResponse =
  paths['/api/trips/{tripId}/basic-activity']['post']['responses']['200']['content']['application/json']

export type AddBasicActivityToTripRequest =
  paths['/api/trips/{tripId}/basic-activity']['post']['requestBody']['content']['application/json']

export type GenerateSuggestedLocationsResponse =
  paths['/api/trips/generate-suggested-locations']['post']['responses']['200']['content']['application/json']

export type GenerateSuggestedLocationsRequest =
  paths['/api/trips/generate-suggested-locations']['post']['requestBody']['content']['application/json']

export type AddBasicActivityToTripError =
  | paths['/api/trips/{tripId}/basic-activity']['post']['responses']['400']['content']['application/json']
  | paths['/api/trips/{tripId}/basic-activity']['post']['responses']['403']['content']['application/json']
  | paths['/api/trips/{tripId}/basic-activity']['post']['responses']['404']['content']['application/json']
  | paths['/api/trips/{tripId}/basic-activity']['post']['responses']['500']['content']['application/json']

export type GetChatResponse = TripPlannerChatDetails

export interface DeleteChatResponse {
  success: boolean
}

export interface ClaimChatsRequest {
  visitorId: string
}

export interface ClaimChatsResponse {
  transferredChats: number
}

export type DeleteStopResponse =
  paths['/api/trips/v2/stops/{stopId}']['delete']['responses']['200']['content']['application/json']['result']

export type DeleteDayResponse =
  paths['/api/trips/v2/days/{dayId}']['delete']['responses']['200']['content']['application/json']['result']

export type DeleteItemResponse =
  paths['/api/trips/v2/items/{itemId}']['delete']['responses']['200']['content']['application/json']['result']

export type SwitchDefaultTransportResponse =
  paths['/api/trips/v2/items/{itemId}/default-transport']['patch']['responses']['200']['content']['application/json']['result']

export type GetItineraryResponse =
  paths['/api/trips/v2/chats/{chatId}/itinerary']['get']['responses']['200']['content']['application/json']

export type GetPlaceDetailResponse =
  paths['/api/trips/v2/places/{googlePlaceId}']['get']['responses']['200']['content']['application/json']

export type GetPlaceDetailResult = GetPlaceDetailResponse['result']

export type GetPlaceOverviewResponse =
  paths['/api/trips/v2/places/{googlePlaceId}/overview']['get']['responses']['200']['content']['application/json']

export type GetPlaceOverviewResult = GetPlaceOverviewResponse['result']

export type GetPlaceBestTimeToVisitResponse =
  paths['/api/trips/v2/places/{googlePlaceId}/best-time-to-visit']['get']['responses']['200']['content']['application/json']

export type GetPlaceBestTimeToVisitResult = GetPlaceBestTimeToVisitResponse['result']

export type GetPlaceWhatToLoveResponse =
  paths['/api/trips/v2/places/{googlePlaceId}/what-to-love']['get']['responses']['200']['content']['application/json']

export type GetPlaceWhatToLoveResult = GetPlaceWhatToLoveResponse['result']

export type GetPlaceAreasResponse =
  paths['/api/trips/v2/places/{googlePlaceId}/areas']['get']['responses']['200']['content']['application/json']

export type GetPlaceAreasResult = GetPlaceAreasResponse['result']

export type GetPlaceInsiderTipsResponse =
  paths['/api/trips/v2/places/{googlePlaceId}/insider-tips']['get']['responses']['200']['content']['application/json']

export type GetPlaceInsiderTipsResult = GetPlaceInsiderTipsResponse['result']

export type GetPlaceHighlightsResponse =
  paths['/api/trips/v2/places/{googlePlaceId}/highlights']['get']['responses']['200']['content']['application/json']

export type GetPlaceHighlightsResult = GetPlaceHighlightsResponse['result']

export type GetPlaceInfoResponse =
  paths['/api/trips/v2/places/{googlePlaceId}/info']['get']['responses']['200']['content']['application/json']

export type GetPlaceInfoResult = GetPlaceInfoResponse['result']

export type PlaceOpeningHours = NonNullable<GetPlaceInfoResult['openingHours']>

export type PlaceInfoReview = NonNullable<GetPlaceInfoResult['reviews']>[number]

export type LocationDrawImagesRequest =
  paths['/api/trips/v2/location-draw-images']['post']['requestBody']['content']['application/json']

export type LocationDrawImagesResponse =
  paths['/api/trips/v2/location-draw-images']['post']['responses']['200']['content']['application/json']

export type LocationDrawImagesResult =
  paths['/api/trips/v2/location-draw-information']['post']['responses']['200']['content']['application/json']

export type LocationDrawInformationRequest =
  paths['/api/trips/v2/location-draw-information']['post']['requestBody']['content']['application/json']

export type PlaceDrawDetailsRequest =
  paths['/api/trips/v2/place-draw-details']['post']['requestBody']['content']['application/json']

export type PlaceDrawDetailsResponse =
  paths['/api/trips/v2/place-draw-details']['post']['responses']['200']['content']['application/json']

export type HotelSearchResponse =
  paths['/api/trips/v2/search/hotels']['get']['responses']['200']['content']['application/json']

export type HotelSearchResultItem = HotelSearchResponse['result'][number]

export type HotelSearchSavedItemData = NonNullable<HotelSearchResultItem['savedItemData']>

export type OfferDetailResponse =
  paths['/api/trips/v2/offers/{offerId}']['get']['responses']['200']['content']['application/json']

export type OfferDetailResult = OfferDetailResponse['result']

export type OfferReviewsResponse =
  paths['/api/trips/v2/offers/{offerId}/reviews']['get']['responses']['200']['content']['application/json']

export type OfferReviewsResult = OfferReviewsResponse['result']

export type ExperienceDetailResponse =
  paths['/api/trips/v2/experience-offers/{offerId}']['get']['responses']['200']['content']['application/json']

export type ExperienceDetailResult = ExperienceDetailResponse['result']

export type ExperienceSearchResponse =
  paths['/api/trips/v2/search/experiences']['get']['responses']['200']['content']['application/json']

export type ExperienceSearchResultItem = ExperienceSearchResponse['result'][number]
